import { Switch, SwitchProps } from "@mui/material";
import { MuiToggleSwitchWrapper } from "./MuiToggleSwitch.style";

interface MuiToggleSwitchProps extends SwitchProps {
  onCheckedChange?: (checked: boolean) => void;
}
export const MuiToggleSwitch = ({
  defaultChecked,
  checked = false,
  onCheckedChange,
  ...rest
}: MuiToggleSwitchProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onCheckedChange?.(event.target.checked);
  };

  return (
    <MuiToggleSwitchWrapper>
      <Switch
        checked={checked}
        onChange={handleChange}
        defaultChecked={defaultChecked}
        {...rest}
      />
    </MuiToggleSwitchWrapper>
  );
};
